import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import RefSvc from "@/services/Referensi";

export interface Category {
  id: number;
  title: string;
  val: Array<{
    id: string;
    title: string;
    description: string;
    scoring: number;
  }>;
}

@Module({ dynamic: true, namespaced: true, store, name: "referensi-asesmen" })
class ReferensiAsesmen extends VuexModule {
  fallriskMFS: Array<Category> = [];
  fallriskHumDum: Array<Category> = [];
  nyeriNIPS: Array<Category> = [];
  nyeriFLACC: Array<Category> = [];
  nyeriBPS: Array<Category> = [];
  periksaNadi = [
    {
      id: "r",
      name: "Reguler"
    },
    {
      id: "i",
      name: "Ireguler"
    },
    {
      id: "n",
      name: "Tidak Teraba"
    }
  ];
  sianosisCategory = [
    {
      id: "y",
      name: "Ada"
    },
    {
      id: "n",
      name: "Tidak ada"
    }
  ];
  retraksiCategory = [
    {
      id: "y",
      name: "Ada"
    },
    {
      id: "n",
      name: "Tidak ada"
    }
  ];
  proteinuriaCategory = [
    {
      id: "1",
      name: "+/trace"
    },
    {
      id: "2",
      name: ">= ++"
    },
    {
      id: "x",
      name: "X"
    }
  ];
  locheaCategory = [
    {
      id: "n",
      name: "Normal"
    },
    {
      id: "a",
      name: "Abnormal"
    },
    {
      id: "x",
      name: "X"
    }
  ];

  @Mutation
  SET_FALLRISK_MFS(data: Category[]) {
    this.fallriskMFS = data;
  }

  @Mutation
  SET_FALLRISK_HUMDUM(data: Category[]) {
    this.fallriskHumDum = data;
  }

  @Mutation
  SET_NYERI_NIPS(data: Category[]) {
    this.nyeriNIPS = data;
  }

  @Mutation
  SET_NYERI_FLACC(data: Category[]) {
    this.nyeriFLACC = data;
  }

  @Mutation
  SET_NYERI_BPS(data: Category[]) {
    this.nyeriBPS = data;
  }

  @Action({ rawError: true })
  async getFallriskMFS() {
    const resp = await RefSvc.getMorseFallScale();

    this.SET_FALLRISK_MFS(resp);
  }

  @Action({ rawError: true })
  async getFallriskHumDum() {
    const resp = await RefSvc.getHumptyDumpty();

    this.SET_FALLRISK_HUMDUM(resp);
  }

  @Action({ rawError: true })
  async getNyeriNIPS() {
    const resp = await RefSvc.getNyeriNips();

    this.SET_NYERI_NIPS(resp);
  }

  @Action({ rawError: true })
  async getNyeriFLACC() {
    const resp = await RefSvc.getNyeriFlacc();

    this.SET_NYERI_FLACC(resp);
  }

  @Action({ rawError: true })
  async getNyeriBPS() {
    const resp = await RefSvc.getNyeriBps();

    this.SET_NYERI_BPS(resp);
  }
}

export default getModule(ReferensiAsesmen);
